import { z } from 'zod'

// Warranty metadata schema for attachments
export const warrantyMetadataSchema = z.object({
  category: z.literal('warranty'),
  deviceName: z.string().min(1, 'Anna laitteen nimi'), // Required device name
  expiryDate: z.string(), // ISO date string
  purchaseDate: z.string().optional(), // ISO date string
  seller: z.string().optional(), // Where purchased
  notes: z.string().optional(),
})

export type WarrantyMetadata = z.infer<typeof warrantyMetadataSchema>

// Helper to check if warranty is expired
export function isWarrantyExpired(expiryDate: string): boolean {
  return new Date(expiryDate) < new Date()
}

// Helper to check if warranty is expiring soon (within 30 days)
export function isWarrantyExpiringSoon(expiryDate: string): boolean {
  const expiry = new Date(expiryDate)
  const now = new Date()
  const daysUntilExpiry = Math.ceil(
    (expiry.getTime() - now.getTime()) / (1000 * 60 * 60 * 24),
  )
  return daysUntilExpiry > 0 && daysUntilExpiry <= 30
}

// Helper to get days until expiry
export function getDaysUntilExpiry(expiryDate: string): number {
  const expiry = new Date(expiryDate)
  const now = new Date()
  return Math.ceil((expiry.getTime() - now.getTime()) / (1000 * 60 * 60 * 24))
}
